class ContactPage {
	constructor() {
		if (!document.body.classList.contains("page-template-template-contact")) {
			return;
		}
		const paths = document.querySelectorAll(".svg-map-container path.zone");
		const cards = document.querySelectorAll(".svg-map-container .info-card-container");
		paths.forEach(path => {
			path.addEventListener("click", () => {
				cards.forEach(card => {
					if (card.dataset.zoneName === path.id) {
						card.classList.add("active");
					} else {
						card.classList.remove("active");
					}
				});
				paths.forEach(otherPath => {
					if (otherPath.id === path.id) {
						otherPath.classList.add("active");
					} else {
						otherPath.classList.remove("active");
					}
				});
			});
		});

		document.querySelectorAll(".svg-map-container .info-card-container .close").forEach(closeBtn => {
			closeBtn.addEventListener("click", () => {
				const card = closeBtn.closest(".info-card-container");
				card.classList.remove("active");
				document.querySelector(".svg-map-container path#" + card.dataset.zoneName).classList.remove("active");
			});
		});
	}
}
